module.exports = __webpack_public_path__ + "img/overview_matchreault_nodata.c27f01cf.png";